import React, { useRef, useMemo } from 'react';
import './servicesForm.css';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { selectAction, setServicesFormAction, userFormAction } from "../../redux/rootReducer";
import { SELECT_INITIAL, SERVICES_FORM_INITIAL, USER_FORM_INITIAL } from "../../redux/initialStateConstant";
import { getUsersForSubscriptionSagaAction } from "../../redux/sagaActions";
import Select from "../Select/Select";
import TextareaAutosize from "react-textarea-autosize";
import { UpdateReserveThunk } from "../../redux/thunks/UpdateReserveThunk";
import { RemoveReserveThunk } from "../../redux/thunks/RemoveReserveThunk";

const ServicesForm = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const services = useSelector(state => state.services);
    const services_form = useSelector(state => state.services_form);

    // Таймер для отсрочки запроса посетителей на сервере
    const timer = useRef(0);

    const getUsers = text => {

        if (timer.current) clearTimeout(timer.current);

        if (!text.trim()) {
            dispatch(setServicesFormAction({
                ...services_form,
                users: [],
                userInput: ''
            }));
            return false;
        }

        // Делаем задержку для набора текста
        timer.current = setTimeout(() => {
            dispatch(getUsersForSubscriptionSagaAction({ text, type: 'services_form' }));
        }, 500);
    };

    // Функция для фильтрации доступных услуг
    const getAvailableServices = useMemo(() => {
        if (!services.services?.length) return [];

        // Получаем ID уже выбранных услуг
        const selectedServiceIds = services_form.services.map(service => service.id);

        // Фильтруем услуги:
        // 1. Исключаем уже выбранные услуги
        // 2. Оставляем только услуги соответствующей специализации
        return services.services.filter(service => {
            // Проверяем, не выбрана ли услуга
            if (selectedServiceIds.includes(service.id)) return false;

            // Проверяем выполняется ли услуга мастером
            return service.master_id === services_form.master.id;
        });

    }, [services.services, services_form.services]);

    return (
        <div className={ `services_form ${ services_form.open ? 'services_form--open' : '' }` }>
            <div className="services_form__content">
                <div className="services_form__header">
                    <div className="services_form__close"
                        onClick={ () => {
                            dispatch(setServicesFormAction(SERVICES_FORM_INITIAL));
                        } }
                    />
                    <div className="services_form__title">Запись на услуги</div>
                    <div className={ `services_form__remove ${ services_form.id === 0 ? 'services_form__remove--empty' : '' }` }
                         onClick={ () => {
                             if (services_form.id === 0) return;

                             if (!window.confirm('Вы действительно хотите удалить запись?')) return;

                             dispatch(RemoveReserveThunk({
                                 reserve_id: services_form.id
                             }));
                         } }
                    />
                </div>
                <div className="services_form__field">
                    <div className="services_form__caption">Мастер</div>
                    <div className="services_form__value">{ services_form.master.name }</div>
                </div>
                <div className="services_form__field">
                    <div className="services_form__caption">Дата и время</div>
                    <div className="services_form__value">{ `${ new Date(services_form.date).toLocaleDateString('ru-Ru') } в ${ services_form.time }`}</div>
                </div>
                <div className="services_form__field">
                    <div className="services_form__caption">Посетитель</div>
                    {
                        services_form.user.id && services_form.user.name
                        ?
                        <>
                            <div className="services_form__value-wrapper">
                                <div className="services_form__value">{ services_form.user.name }</div>
                                <div className="services_form__clear"
                                    onClick={ () => {
                                        dispatch(setServicesFormAction({
                                            ...services_form,
                                            user: { id: '', name: '', phone: '' }
                                        }));
                                    } }
                                />
                            </div>
                        </>
                        :
                        <>
                            <div className="dropdown">
                                <input type="text" className="input"
                                       value={ services_form.userInput || '' }
                                       onInput={ event => {
                                           dispatch(setServicesFormAction({
                                               ...services_form,
                                               userInput: event.target.value
                                           }));
                                           // Получение с сервера списка всех пользователей, с совпадением по email или телефону
                                           getUsers(event.target.value);
                                       } }
                                       disabled={ services_form.canceled }
                                />
                                <div className={ `dropdown__items ${ services_form.userInput ? 'dropdown__items--open' : false }` }>
                                    {
                                        services_form.users?.length
                                            ? services_form?.users?.map(elem => {
                                                return (
                                                    <div className="dropdown__item" key={ elem.id }
                                                         onClick={ () => {
                                                             dispatch(setServicesFormAction({
                                                                 ...services_form,
                                                                 user: { id: elem.id, name: elem.name, phone: elem.phone },
                                                                 userInput: ''
                                                             }));

                                                         } }
                                                    >{ `${ elem.name } ${ elem.phone }` }</div>
                                                );
                                            })
                                            : <div className="dropdown__item"
                                                   onClick={ () => {
                                                       // Переходим на страницу с посетителями
                                                       history.push('/fitness/users');
                                                       // Закрываем форму добавления абонемента
                                                       dispatch(setServicesFormAction(SERVICES_FORM_INITIAL));
                                                       // Открываем форму добавления посетителя
                                                       dispatch(userFormAction({
                                                           ...USER_FORM_INITIAL,
                                                           open: true,
                                                           title: 'Новый посетитель'
                                                       }));
                                                   } }
                                            >{ `Добавить посетителя` }</div>
                                    }
                                </div>
                            </div>
                        </>
                    }
                </div>
                <div className="services_form__field">
                    <div className="services_form__caption">Услуги</div>
                    <div className="services_form__select-services">
                        {
                            services_form.services.map((elem, index) => (
                                <div className="services_form__value-wrapper" key={ index }>
                                    <div className="services_form__value">{ elem.name }</div>
                                    <div className="services_form__clear"
                                        onClick={ () => {
                                            // Копируем массив с услугами
                                            let select_services_copy = [...services_form.services];
                                            // Удаляем услугу по индексу
                                            select_services_copy.splice(index, 1);

                                            // Сохраняем отфильтрованных список услуг
                                            dispatch(setServicesFormAction({
                                                ...services_form,
                                                services: select_services_copy
                                            }));
                                        } }
                                    />
                                </div>
                            ))
                        }
                    </div>

                    <div className="services_form__set-service">
                        <Select
                            current={ 'Укажите услугу' }
                            type={ 'ser_service' }
                            options={ getAvailableServices }
                            handler={ service => {

                                if (services_form.services.includes(service)) {
                                    alert('Услуга уже выбрана'); return;
                                }

                                // Сохраняем услугу в списке
                                dispatch(setServicesFormAction({
                                    ...services_form,
                                    services: [...services_form.services, service]
                                }));
                                dispatch(selectAction(SELECT_INITIAL));
                            } }
                            smart={ true }
                        />
                    </div>
                </div>

                <div className="services_form__field">
                    <div className="services_form__caption">Примечание</div>
                    <TextareaAutosize
                        className="input input--textarea"
                        value={ services_form.note }
                        onInput={ event => {
                            dispatch(setServicesFormAction({
                                ...services_form,
                                note: event.target.value
                            }));
                        } }
                    />
                </div>

                <div className="services_form__field">
                    <div className="button"
                        onClick={ () => {
                            dispatch(UpdateReserveThunk({
                                id: services_form.id,
                                master: services_form.master.id,
                                date: services_form.date,
                                time: services_form.time,
                                services: services_form.services.map(elem => elem.id),
                                user: services_form.user.id,
                                note: services_form.note
                            }));
                        } }
                    >Сохранить</div>
                    {
                        services_form.id > 0 &&
                        <div
                            style={{ marginTop: 12 }}
                            className="button button--blue"
                            onClick={ () => {
                                dispatch(setServicesFormAction({
                                    ...services_form,
                                    edit_mode: true
                                }));
                            } }
                        >Редактировать</div>
                    }
                </div>
            </div>
        </div>
    );
};

export default ServicesForm;